import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AuthGuardGuard } from './modules/services/auth-guard';
import { authInterceptor } from './modules/services/interceptor';
import { ClientSideRowModelModule, ValidationModule } from 'ag-grid-community';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { NgxSpinnerService } from 'ngx-spinner';
import { HighchartsChartModule } from 'highcharts-angular';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

ModuleRegistry.registerModules([AllCommunityModule, ClientSideRowModelModule, ValidationModule,]);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimationsAsync(),
    provideRouter(routes, withComponentInputBinding(), withRouterConfig({ onSameUrlNavigation: 'reload' })),
    provideHttpClient(withInterceptors([authInterceptor])),
    importProvidersFrom(HighchartsChartModule, NgxDaterangepickerMd.forRoot()),
    AuthGuardGuard,
    NgxSpinnerService,
  ],
};
